/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Files_On_Message_ErrorInputs */

const es_tools_nexata_list_files_on_message_error = /** @type {(inputs: Tools_Nexata_List_Files_On_Message_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar archivos del mensaje`)
};

const en_tools_nexata_list_files_on_message_error = /** @type {(inputs: Tools_Nexata_List_Files_On_Message_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing message files`)
};

/**
* | output |
* | --- |
* | "Error listing message files" |
*
* @param {Tools_Nexata_List_Files_On_Message_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_files_on_message_error = /** @type {((inputs?: Tools_Nexata_List_Files_On_Message_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Files_On_Message_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_files_on_message_error(inputs)
	return en_tools_nexata_list_files_on_message_error(inputs)
});
export { tools_nexata_list_files_on_message_error as "tools.nexata.list_files_on_message_error" }